<template>
  <div class="big-data-view">
    <!-- Header Section -->
    <div class="header-section">
      <div class="header-left">
        <span class="datetime">更新时间：{{ currentDateTime }}</span>
      </div>
      <div class="header-center">
        <h1 class="system-title">推广部项目进度系统</h1>
      </div>
      <div class="header-left" style="opacity: 0;">
        <span class="datetime">更新时间：{{ currentDateTime }}</span>
      </div>
    </div>

    <!-- Filter and Statistics Section -->
    <div class="filter-stats-section">
      <div class="filter-section">
        <el-form :inline="true" size="small" class="filter-form">
          <el-form-item label="省份">
            <el-select
              v-model="provinceFilter"
              placeholder="请选择省份"
              class="filter-input"
              clearable>
              <el-option
                v-for="item in provinceOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="城市">
            <el-select
              v-model="cityFilter"
              placeholder="请选择城市"
              class="filter-input"
              clearable
              filterable>
              <el-option
                v-for="item in cityOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="项目">
            <el-select
              v-model="projectFilter"
              placeholder="请选择项目"
              class="filter-input"
              clearable
              filterable>
              <el-option
                v-for="item in projectOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="canViewAllData">
            <el-switch
              v-model="showPersonalPanel"
              active-text="查看个人数据"
              inactive-text="查看全国数据"
              @change="handlePersonalPanelChange">
            </el-switch>
          </el-form-item>
        </el-form>
        <div class="filter-button-row">
          <el-button
            type="primary"
            @click="handleFilter"
            class="filter-btn">
            筛选
          </el-button>
        </div>
      </div>

      <div class="stats-section">
        <div class="stats-title">统计</div>
        <div class="stats-grid">
          <div class="stat-item">
            <div class="stat-label">项目数量</div>
            <div class="stat-value">{{ statistics.projectCount }}</div>
          </div>
          <div class="stat-item">
            <div class="stat-label">城市数量</div>
            <div class="stat-value">{{ statistics.cityCount }}</div>
          </div>
          <div class="stat-item">
            <div class="stat-label">进度偏差正值城市数</div>
            <div class="stat-value positive">{{ statistics.positiveDeviationCount }}</div>
          </div>
          <div class="stat-item">
            <div class="stat-label">进度偏差负值城市数</div>
            <div class="stat-value negative">{{ statistics.negativeDeviationCount }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- Table Section -->
    <div class="table-section">
      <div class="table-title">项目执行明细 <span style="font-size: 12px; color: #999">(目标数量，增长，当前完成率，进度偏差值数据的排序只在同项目内生效)</span></div>
      <el-table
        :data="tableData"
        stripe
        border
        @sort-change="handleSortChange"
        :span-method="objectSpanMethod"
        style="width: 100%"
        :header-cell-style="{ background: '#f5f7fa', color: '#606266', fontWeight: 'bold' }"
        :height="tableHeight">
        <el-table-column
          prop="project"
          label="项目"
          min-width="100"
          fixed="left"
          align="center">
        </el-table-column>
        <el-table-column
          prop="province"
          label="省份"
          width="100"
          align="center">
        </el-table-column>
        <el-table-column
          prop="city"
          label="城市"
          width="100"
          align="center">
        </el-table-column>
        <el-table-column
          prop="manager"
          label="负责人"
          width="120"
          align="center">
        </el-table-column>
        <el-table-column
          prop="targetQuantity"
          label="目标数量"
          width="110"
          sortable="custom"
          align="center">
          <template slot="header">
            <el-tooltip class="item" effect="dark" content="排序只在同项目内生效" placement="top">
              <span>目标数量</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column
          prop="yesterdayCompleted"
          label="昨日完成"
          width="110"
          align="center">
        </el-table-column>
        <el-table-column
          prop="currentCompleted"
          label="当前完成"
          width="110"
          align="center">
        </el-table-column>
        <el-table-column
          prop="growth"
          label="增长"
          width="100"
          sortable="custom"
          align="center">
          <template slot="header">
            <el-tooltip class="item" effect="dark" content="排序只在同项目内生效" placement="top">
              <span>增长</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column
          prop="completionRate"
          label="当前完成率"
          width="130"
          sortable="custom"
          align="center">
          <template slot="header">
            <el-tooltip class="item" effect="dark" content="排序只在同项目内生效" placement="top">
              <span>当前完成率</span>
            </el-tooltip>
          </template>
          <template slot-scope="scope">
            {{ scope.row.completionRate }}%
          </template>
        </el-table-column>
        <el-table-column
          prop="progressDeviation"
          label="进度偏差值"
          width="130"
          sortable="custom"
          align="center">
          <template slot="header">
            <el-tooltip class="item" effect="dark" content="排序只在同项目内生效" placement="top">
              <span>进度偏差值</span>
            </el-tooltip>
          </template>
          <template slot-scope="scope">
            <span
              :class="scope.row.progressDeviation >= 0 ? 'deviation-positive' : 'deviation-negative'"
              class="deviation-value">
              <i :class="scope.row.progressDeviation >= 0 ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
              {{ Math.abs(scope.row.progressDeviation) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="activeUsers"
          label="活跃用户"
          min-width="110"
          align="center">
        </el-table-column>
        <el-table-column
          prop="standbyUsers"
          label="待机用户"
          min-width="110"
          align="center">
        </el-table-column>
        <el-table-column
          prop="participatingUsers"
          label="参与用户数"
          width="120"
          align="center">
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'BigDataView',
  data () {
    return {
      currentDateTime: '',
      provinceFilter: '',
      cityFilter: '',
      projectFilter: '',
      selectedProvince: '',
      selectedCity: '',
      selectedProject: '',
      canViewAllData: false,
      showPersonalPanel: false, // 是否显示个人面板
      provinceOptions: [], // 省份选项列表
      cityOptions: [], // 城市选项列表（当前选中的省份下的城市）
      allCityOptions: [], // 所有城市选项列表（用于联动）
      projectOptions: [], // 项目选项列表
      provinceCityMap: {}, // 省份-城市映射
      allTableData: [], // 保存所有原始数据，用于本地筛选
      statistics: {
        projectCount: 0,
        cityCount: 0,
        positiveDeviationCount: 0,
        negativeDeviationCount: 0
      },
      tableData: [],
      sortConfig: {},
      tableHeight: 600,
      projectSpanArr: [], // 存储项目列的合并信息
      loading: false
    }
  },
  computed: {
    ...Vuex.mapState({
      user: state => state.login.user,
    }),
  },
  watch: {
    tableData: {
      handler () {
        this.getProjectSpanArr()
      },
      immediate: true
    },
    provinceFilter (newVal) {
      // 省份变化时，清空城市选择，更新城市选项
      if (newVal !== this.selectedProvince) {
        this.cityFilter = ''
        this.updateCityOptions(newVal)
      }
    }
  },
  mounted () {
    this.updateDateTime()
    // // 每秒更新一次时间
    // setInterval(() => {
    //   this.updateDateTime()
    // }, 1000)
    // 计算表格高度
    this.calculateTableHeight()
    // 监听窗口大小变化
    window.addEventListener('resize', this.calculateTableHeight)
    // 加载数据
    this.loadData()
  },
  beforeDestroy () {
    // 移除窗口大小变化监听
    window.removeEventListener('resize', this.calculateTableHeight)
  },
  methods: {
    /**
     * 计算项目列的合并信息
     */
    getProjectSpanArr () {
      this.projectSpanArr = []
      if (this.tableData.length === 0) {
        return
      }

      // 初始化数组，每个元素代表该行的rowspan，默认为0
      this.projectSpanArr = new Array(this.tableData.length).fill(0)

      // 遍历表格数据，找到每个项目组的起始位置和行数
      let currentProject = null
      let startIndex = 0

      for (let i = 0; i < this.tableData.length; i++) {
        const project = this.tableData[i].project

        if (currentProject === null) {
          // 第一个项目
          currentProject = project
          startIndex = i
        } else if (project !== currentProject) {
          // 遇到新项目，计算上一个项目组的行数
          const rowspan = i - startIndex
          this.projectSpanArr[startIndex] = rowspan
          // 开始新的项目组
          currentProject = project
          startIndex = i
        }
      }

      // 处理最后一个项目组
      if (currentProject !== null) {
        const rowspan = this.tableData.length - startIndex
        this.projectSpanArr[startIndex] = rowspan
      }
    },
    /**
     * 单元格合并方法
     * @param {Object} param - { row, column, rowIndex, columnIndex }
     * @returns {Object} - { rowspan, colspan }
     */
    objectSpanMethod ({ row, column, rowIndex, columnIndex }) {
      // 只合并第一列（项目列）
      if (columnIndex === 0) {
        const rowspan = this.projectSpanArr[rowIndex]
        const colspan = rowspan > 0 ? 1 : 0
        return {
          rowspan: rowspan,
          colspan: colspan
        }
      }
      // 其他列不合并
      return {
        rowspan: 1,
        colspan: 1
      }
    },
    calculateTableHeight () {
      // 计算表格高度：视口高度 - 头部 - 筛选统计区域 - 表格标题和padding
      const headerHeight = 60
      const filterStatsHeight = 180
      const tableSectionPadding = 80
      this.tableHeight = window.innerHeight - headerHeight - filterStatsHeight - tableSectionPadding
    },
    updateDateTime () {
      this.currentDateTime = moment().format('YYYY-MM-DD HH:00:00')
    },
    /**
     * 获取当前登录用户ID
     */
    getCurrentUserId () {
      return this.user.id * 1
    },
    /**
     * 筛选按钮点击事件
     */
    handleFilter () {
      this.selectedProvince = this.provinceFilter || ''
      this.selectedCity = this.cityFilter || ''
      this.selectedProject = this.projectFilter || ''
      // 本地筛选数据
      this.filterLocalData()
    },
    /**
     * 个人面板开关变化事件
     */
    handlePersonalPanelChange (value) {
      // 显示loading
      const loading = this.$loading({
        lock: true,
        text: '数据处理中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      // 延迟执行筛选,让loading有足够时间显示
      setTimeout(() => {
        // 重新筛选数据
        this.filterLocalData()
        // 关闭loading
        loading.close()
      }, 300)
    },
    /**
     * 本地筛选数据
     */
    filterLocalData () {
      let filteredData = [...this.allTableData]

      // 个人面板：只显示当前登录用户的数据
      if (this.showPersonalPanel) {
        const currentUserId = this.getCurrentUserId()
        filteredData = filteredData.filter(item => {
          return item._raw && item._raw.member_adminid * 1 === currentUserId
        })
      }

      // 根据省份筛选
      if (this.provinceFilter) {
        filteredData = filteredData.filter(item => {
          return item._raw && item._raw.province_name === this.provinceFilter
        })
      }

      // 根据城市筛选
      if (this.cityFilter) {
        filteredData = filteredData.filter(item => {
          return item._raw && item._raw.city_name === this.cityFilter
        })
      }

      // 根据项目筛选
      if (this.projectFilter) {
        filteredData = filteredData.filter(item => {
          return item._raw && item._raw.project_name === this.projectFilter
        })
      }

      this.tableData = filteredData
      // 重新计算统计数据（基于筛选后的数据）
      this.calculateStatisticsFromTableData()
    },
    /**
     * 加载数据（只在页面刷新时调用）
     */
    loadData () {
      this.loading = true
      // 不传省份参数，获取所有数据
      request.page('getBigDataResult', {adminid: this.getCurrentUserId()}).then(({data}) => {
        this.canViewAllData = _.get(data, 'view_national_data', false)
        if (Array.isArray(data.data) && data.data.length > 0) {
          // 转换数据格式
          this.allTableData = this.transformTableData(data.data)
          // 提取省份选项
          this.extractProvinceOptions(data.data)
          // 提取城市选项
          this.extractCityOptions(data.data)
          // 提取项目选项
          this.extractProjectOptions(data.data)
          // 默认显示全部数据
          this.tableData = [...this.allTableData]
          // 计算统计数据（全部数据）
          this.calculateStatisticsFromTableData()
          // 更新当前时间
          this.updateDateTime()
        } else {
          this.allTableData = []
          this.tableData = []
          this.provinceOptions = []
          this.cityOptions = []
          this.allCityOptions = []
          this.provinceCityMap = {}
          this.projectOptions = []
          this.statistics = {
            projectCount: 0,
            cityCount: 0,
            positiveDeviationCount: 0,
            negativeDeviationCount: 0
          }
        }
      }).catch((error) => {
        console.error('加载数据失败:', error)
        this.$message.error('加载数据失败，请稍后重试')
      }).finally(() => {
        this.loading = false
      })
    },
    /**
     * 提取省份选项
     */
    extractProvinceOptions (detail) {
      const provinceSet = new Set()
      if (detail && Array.isArray(detail)) {
        detail.forEach(item => {
          if (item.province_name) {
            provinceSet.add(item.province_name)
          }
        })
      }
      // 转换为选项数组
      this.provinceOptions = Array.from(provinceSet).map(name => ({
        label: name,
        value: name
      })).sort((a, b) => a.label.localeCompare(b.label)) // 按名称排序
    },
    /**
     * 提取城市选项并构建省份-城市映射
     */
    extractCityOptions (detail) {
      this.provinceCityMap = {}
      const allCitySet = new Set()

      if (detail && Array.isArray(detail)) {
        detail.forEach(item => {
          const provinceName = item.province_name
          const cityName = item.city_name

          if (provinceName && cityName) {
            // 构建省份-城市映射
            if (!this.provinceCityMap[provinceName]) {
              this.provinceCityMap[provinceName] = new Set()
            }
            this.provinceCityMap[provinceName].add(cityName)

            // 收集所有城市
            allCitySet.add(cityName)
          }
        })
      }

      // 转换所有城市选项数组（初始显示所有城市）
      this.allCityOptions = Array.from(allCitySet).map(name => ({
        label: name,
        value: name
      })).sort((a, b) => a.label.localeCompare(b.label))

      // 初始城市选项显示所有
      this.cityOptions = [...this.allCityOptions]
    },
    /**
     * 根据选中的省份更新城市选项
     */
    updateCityOptions (province) {
      if (!province) {
        // 如果没有选择省份，显示所有城市
        this.cityOptions = [...this.allCityOptions]
      } else {
        // 根据选中的省份筛选城市
        const cities = this.provinceCityMap[province]
        if (cities) {
          this.cityOptions = Array.from(cities).map(name => ({
            label: name,
            value: name
          })).sort((a, b) => a.label.localeCompare(b.label))
        } else {
          this.cityOptions = []
        }
      }
    },
    /**
     * 提取项目选项
     */
    extractProjectOptions (detail) {
      const projectSet = new Set()
      if (detail && Array.isArray(detail)) {
        detail.forEach(item => {
          if (item.project_name) {
            projectSet.add(item.project_name)
          }
        })
      }
      // 转换为选项数组
      this.projectOptions = Array.from(projectSet).map(name => ({
        label: name,
        value: name
      })).sort((a, b) => a.label.localeCompare(b.label)) // 按名称排序
    },
    /**
     * 转换表格数据格式
     */
    transformTableData (detail) {
      if (!detail || !Array.isArray(detail)) {
        return []
      }

      return detail.map(item => {
        // 将接口字段映射到表格字段
        return {
          project: item.project_name || '',
          province: item.province_name || '',
          city: item.city_name || '', // 保留城市字段，可能用于其他用途
          manager: item.member_name || '', // 负责人
          targetQuantity: parseInt(item.target_order_count) || 0,
          yesterdayCompleted: parseInt(item.yesterday_complete_count) || 0,
          currentCompleted: parseInt(item.current_complete_count) || 0,
          growth: parseInt(item.growth_count) || 0,
          completionRate: parseFloat(item.current_complete_ratio) || 0,
          progressDeviation: parseInt(item.schedule_variance) || 0,
          activeUsers: parseInt(item.active_user_count) || 0,
          standbyUsers: parseInt(item.inactive_user_count) || 0,
          participatingUsers: parseInt(item.involved_user_count) || 0,
          // 保留原始数据，用于筛选等操作
          _raw: item
        }
      })
    },
    /**
     * 根据表格数据计算统计数据（用于本地筛选后的统计）
     */
    calculateStatisticsFromTableData () {
      if (!this.tableData || this.tableData.length === 0) {
        this.statistics = {
          projectCount: 0,
          cityCount: 0,
          positiveDeviationCount: 0,
          negativeDeviationCount: 0
        }
        return
      }

      // 获取所有唯一的项目
      const projects = new Set()
      // 获取所有唯一的城市
      const cities = new Set()
      // 统计进度偏差正值和负值的城市数
      const positiveCities = new Set()
      const negativeCities = new Set()

      this.tableData.forEach(item => {
        if (item.project) {
          projects.add(item.project)
        }
        if (item.city) {
          cities.add(item.city)
          // 判断进度偏差值的正负
          const variance = item.progressDeviation || 0
          if (variance > 0) {
            positiveCities.add(item.city)
          } else if (variance < 0) {
            negativeCities.add(item.city)
          }
        }
      })

      this.statistics = {
        projectCount: projects.size,
        cityCount: cities.size,
        positiveDeviationCount: positiveCities.size,
        negativeDeviationCount: negativeCities.size
      }
    },
    handleLogout () {
      this.$confirm('确认退出登录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 这里可以添加退出登录逻辑
        this.$message.success('退出登录成功')
        // this.$store.commit('LOGOUT')
        // this.$router.push('/login')
      }).catch(() => {})
    },
    handleSortChange ({ column, prop, order }) {
      // 处理排序
      if (order) {
        this.sortConfig = { prop, order }
        this.sortTableData(prop, order)
      } else {
        this.sortConfig = {}
        // 恢复原始数据顺序 - 重新加载数据
        this.resetTableData()
      }
    },
    sortTableData (prop, order) {
      // 为了保持项目合并功能，需要先按项目分组，然后在项目组内排序
      const data = [...this.tableData]

      // 如果排序的列就是项目列，直接排序
      if (prop === 'project') {
        data.sort((a, b) => {
          if (order === 'ascending') {
            return a.project.localeCompare(b.project)
          } else {
            return b.project.localeCompare(a.project)
          }
        })
      } else {
        // 其他列排序：先按项目分组，然后在项目组内按指定列排序
        // 1. 先按项目分组
        const projectGroups = {}
        data.forEach(item => {
          if (!projectGroups[item.project]) {
            projectGroups[item.project] = []
          }
          projectGroups[item.project].push(item)
        })

        // 2. 在每个项目组内排序
        Object.keys(projectGroups).forEach(projectName => {
          projectGroups[projectName].sort((a, b) => {
            let aVal = a[prop]
            let bVal = b[prop]

            // 如果是进度偏差值，需要处理正负值
            if (prop === 'progressDeviation') {
              aVal = a.progressDeviation
              bVal = b.progressDeviation
            }

            if (order === 'ascending') {
              return aVal - bVal
            } else {
              return bVal - aVal
            }
          })
        })

        // 3. 按项目名称排序项目组（保持项目的原始顺序，或者可以按字母序）
        const projectOrder = Array.from(new Set(data.map(item => item.project)))
        const sortedData = []
        projectOrder.forEach(projectName => {
          sortedData.push(...projectGroups[projectName])
        })

        this.tableData = sortedData
        return
      }

      this.tableData = data
    },
    resetTableData () {
      // 重新加载数据
      this.loadData()
    }
  }
}
</script>

<style lang="scss" scoped>
.big-data-view {
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: #f0f2f5;
  padding: 0;
  box-sizing: border-box;
  overflow: hidden;
}

// Header Section
.header-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 30px;
  background-color: #fff;
  border-bottom: 1px solid #e8e8e8;
  height: 60px;
  box-sizing: border-box;
  flex-shrink: 0;

  .header-left {
    flex: 0 0 auto;
    .datetime {
      font-size: 14px;
      color: #606266;
      font-weight: 500;
    }
  }

  .header-center {
    flex: 1;
    text-align: center;
    .system-title {
      font-size: 22px;
      font-weight: bold;
      color: #303133;
      margin: 0;
      letter-spacing: 1px;
    }
  }

  .header-right {
    flex: 0 0 auto;
    text-align: right;
    .logout-btn {
      font-size: 20px;
      color: #606266;
      padding: 5px;
      border: none;
      background: transparent;
      cursor: pointer;
      &:hover {
        color: #409eff;
      }
    }
  }
}

// Filter and Statistics Section
.filter-stats-section {
  display: flex;
  gap: 12px;
  padding: 20px 0;
  background-color: #f0f2f5;
  flex-shrink: 0;
}

.filter-section {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 15px;
  align-items: center;
  background-color: #fff;
  padding: 25px 30px;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);

  .filter-form {
    width: 100%;

    ::v-deep .el-form-item {
      margin-bottom: 0;
    }

    ::v-deep .el-form-item__label {
      font-weight: 500;
      color: #606266;
    }

    .filter-input {
      width: 200px;
    }

    .filter-btn {
      padding: 9px 30px;
      min-width: 100px;
    }

    ::v-deep .el-switch {
      .el-switch__label {
        font-size: 14px;
        font-weight: 500;
        color: #606266;
      }
    }
  }

  .filter-button-row {
    display: flex;
    justify-content: center;
  }

  .selected-province {
    font-size: 20px;
    font-weight: bold;
    color: #303133;
  }
}

.stats-section {
  flex: 1;
  background-color: #fff;
  padding: 25px 30px;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);

  .stats-title {
    font-size: 16px;
    font-weight: bold;
    color: #303133;
    margin-bottom: 25px;
  }

  .stats-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 15px;

    .stat-item {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 15px;
      padding: 10px;
      .stat-label {
        font-size: 14px;
        color: #909399;
        line-height: 1.5;
      }

      .stat-value {
        font-size: 28px;
        font-weight: bold;
        color: #303133;
        line-height: 1.2;

        &.positive {
          color: #67c23a;
        }

        &.negative {
          color: #f56c6c;
        }
      }
    }
  }
}

// Table Section
.table-section {
  flex: 1;
  background-color: #fff;
  padding: 20px;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;

  .table-title {
    font-size: 18px;
    font-weight: bold;
    color: #303133;
    margin-bottom: 15px;
    padding-bottom: 10px;
    border-bottom: 2px solid #e8e8e8;
  }

  // 表格容器
    ::v-deep .el-table {
      flex: 1;

      .el-table__body-wrapper {
        overflow-y: auto;
      }

      th {
        background-color: #f5f7fa !important;
        color: #606266 !important;
        font-weight: 600 !important;
        padding: 12px 0;
        text-align: center;
      }

      td {
        padding: 12px 0;
        text-align: center;
      }

      .el-table__row {
        &:hover {
          background-color: #f5f7fa;
        }
      }

      .el-table__fixed-right {
        height: 100% !important;
      }
    }

  // 进度偏差值样式
  .deviation-value {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    font-weight: bold;
    font-size: 14px;

    &.deviation-positive {
      color: #67c23a;
    }

    &.deviation-negative {
      color: #f56c6c;
    }

    i {
      font-size: 16px;
      font-weight: bold;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/big-data-view/pages/BigDataView.vue